// @flow strict

import * as React from 'react';
import {
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './panel-loader.css';


export const PanelLoader = ({
  title = '',
  showPanelHeader = true,
  size = 'medium',
  delayMs = 200,
}: {
  title?: React.Node,
  showPanelHeader?: boolean,
  size?: 'medium' | 'large',
  delayMs?: number,
}): React.Node => {
  const [shouldShow, setShouldShow] = React.useState(false);
  const timeoutRef = React.useRef<?TimeoutID>(null);

  React.useLayoutEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setShouldShow(true);
    }, delayMs);

    return () => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [delayMs]);

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      {showPanelHeader && (
        <PanelHeader hideCloseBtn>
          <SubTitleLarge>{title}</SubTitleLarge>
        </PanelHeader>
      )}
      <PanelBody className={css.localPanelBody}>
        <CircularLoader
          colorToken="colorFillPrimary"
          size={size === 'medium' ? 'medium' : 'large'}
          className={css.loaderContainer}
        />
      </PanelBody>
    </>
  );
};
